import { put, call, takeLatest, select } from "redux-saga/effects";
import * as types from "../constants/prayerFeatureActionTypes";
import * as consts from "../constants/prayerFeatureConstants";
import {
    client, registerSession, joinCommunity, getAmityToken, getNotificationBadge, markNotificationBadgeAsRead, linkAmityAccount,
    queryAllPosts, queryMyPosts, postPrayer, editPost, deletePrayer, addReaction, removeReaction,
    queryAllComments, getComment, addComment, deleteComment, editComment, addCommentReaction, removeCommentReaction,
    getDeletedPosts, markDeletedPostsAsRead
} from "../api/prayerFeatureApi";
import * as accountApi from "../api/accountApi";
import { ErrorCode } from '@amityco/js-sdk';
import { refresh } from "./ssoSaga";
import * as features from "../constants/MembershipFeatures";
import * as tools from "../helpers/Tools";
import { logUI } from "../api/andyliticsApi";

export default function* prayerFeatureSaga() {
    yield takeLatest(types.SETUP_AMITY_USER_SESSION, setupUserSession);
    yield takeLatest(types.GET_ALL_PRAYERS, handleQueryAllPosts);
    yield takeLatest(types.GET_ALL_PRAYERS_SUCCESS, handleQueryAllPostsSuccess);
    yield takeLatest(types.GET_MY_PRAYERS, handleQueryMyPosts);
    yield takeLatest(types.REFRESH_ALL_PRAYERS, handleRefreshAllPrayers);
    yield takeLatest(types.REFRESH_MY_PRAYERS, handleRefreshMyPrayers);
    yield takeLatest(types.GET_NEXT_PRAYERS, handleNextPrayers);
    yield takeLatest(types.POST_PRAYER, handlePostPrayer);
    yield takeLatest(types.EDIT_PRAYER, handleEditPrayer);
    yield takeLatest(types.DELETE_PRAYER, handleDeletePrayer);
    yield takeLatest(types.ADD_PRAYER_REACTION, handleAddReaction);
    yield takeLatest(types.REMOVE_PRAYER_REACTION, handleRemoveReaction);
    yield takeLatest(types.GET_COMMENTS, handleGetComments);
    yield takeLatest(types.GET_COMMENT, handleGetComment);
    yield takeLatest(types.ADD_COMMENT, handleAddComment);
    yield takeLatest(types.EDIT_COMMENT, handleEditComment);
    yield takeLatest(types.DELETE_COMMENT, handleDeleteComment);
    yield takeLatest(types.ADD_COMMENT_REACTION, handleAddCommentReaction);
    yield takeLatest(types.REMOVE_COMMENT_REACTION, handleRemoveCommentReaction);
    yield takeLatest(types.GET_NOTIFICATION_BADGE, handleGetNotificationBadge);
    yield takeLatest(types.POST_NOTIFICATION_BADGE_ASREAD, handlePostMarkNotificationBadgeAsRead);
    yield takeLatest(types.UPDATE_USER_PREFERENCE, handleUpdateUserPreference);
    yield takeLatest(types.GET_DELETED_POSTS, handleGetDeletedPosts);
    yield takeLatest(types.MARK_DELETED_POST_ASREAD, handleMarkDeletedPostsAsRead);
}

function* isConnected() {
    const prayerFeature = yield select(state => state.prayerFeature);
    const { connectionState, livePrayers } = prayerFeature;
    return !window.isOffline && (connectionState === 'connected' || (connectionState === null && livePrayers && livePrayers.loadingStatus !== 'error'));
};

export function* setupUserSession(payload) {
    let response = null;
    let error = null;
    let memberId = payload.memberId;
    try {
        const domain = yield select(state => state.domain);
        logUI('MBHWeb.PrayerWall.' + types.SETUP_AMITY_USER_SESSION, new Date(), tools.getURLPath(), null, memberId);
        let accessToken = domain.t;
        if (!memberId) {
            const linkedAccount = yield call(linkAmityAccount, accessToken, domain.un);
            const featureAmity = tools.getFeature(linkedAccount, features.Amity);
            memberId = featureAmity && featureAmity.memberId;
            const refreshedAccount = yield call(refresh, { refresh_token: domain.rt });
            accessToken = refreshedAccount && refreshedAccount.access_token;
        }

        let token = yield call(getAmityToken, accessToken);
        if (token && typeof token === 'string') {
            //token = token.replace(/\"/g, '');
            response = yield call(registerSession, memberId, token);
            const communityHasBeenJoined = yield call(joinCommunity);
            console.log('communityHasBeenJoined', communityHasBeenJoined);
            const prayerFeature = yield select(state => state.prayerFeature);
            if (prayerFeature[consts.HIDE_PRAYER_WALL_TOOLTIP] === undefined) {
                const preference = yield call(getUserPreference, consts.HIDE_PRAYER_WALL_TOOLTIP);
                const hidePrayerWallTooltip = preference && preference.length && preference[0].PreferenceValue;
                response[consts.HIDE_PRAYER_WALL_TOOLTIP] = hidePrayerWallTooltip === 'true';
            }
            else {
                response[consts.HIDE_PRAYER_WALL_TOOLTIP] = prayerFeature[consts.HIDE_PRAYER_WALL_TOOLTIP].value;
            }
            yield put({ type: types.SETUP_AMITY_USER_SESSION_SUCCESS, token, memberId });
            logUI('MBHWeb.PrayerWall.' + types.SETUP_AMITY_USER_SESSION_SUCCESS, new Date(), tools.getURLPath(), { token }, memberId);
        }
        else {
            error = 'empty or unknown token';
            yield put({ type: types.SETUP_AMITY_USER_SESSION_FAILURE, error });
            logUI('MBHWeb.PrayerWall.' + types.SETUP_AMITY_USER_SESSION_FAILURE, new Date(), tools.getURLPath(), { error }, memberId);
        }
    }
    catch (err) {
        error = err ? err : 'failed to get token';
        yield put({ type: types.SETUP_AMITY_USER_SESSION_FAILURE, error });
        logUI('MBHWeb.PrayerWall.' + types.SETUP_AMITY_USER_SESSION_FAILURE, new Date(), tools.getURLPath(), { error }, memberId);
    }
    finally {
        if (payload.callback) {
            payload.callback(response, error);
        }
    }
}

function resetLiveObject(liveObject) {
    if (liveObject) {
        liveObject.loadingStatus = undefined;
        if (liveObject.resetPage) {
            liveObject.resetPage();
        }
    }
}

function onOnline() {
    window.isOffline = false;
    //    const prayerFeature = sessionStorage['root'] ? JSON.parse(JSON.parse(sessionStorage['root']).prayerFeature) : window.store.getState();
    //    const { livePrayers, liveMyPrayers } = prayerFeature;
    //    resetLiveObject(livePrayers);
    //    resetLiveObject(liveMyPrayers);
}

function onOffline() {
    window.isOffline = true;
}

window.addEventListener('online', onOnline);
window.addEventListener('offline', onOffline);

export function* cleanupUserSession() {
    const prayerFeature = yield select(state => state.prayerFeature);
    if (prayerFeature.livePrayers) {
        prayerFeature.livePrayers.removeAllListeners('dataUpdated');
        prayerFeature.livePrayers.dispose();
    }
    if (prayerFeature.liveMyPrayers) {
        prayerFeature.liveMyPrayers.removeAllListeners('dataUpdated');
        prayerFeature.liveMyPrayers.dispose();
    }
    client.unregisterSession();
    client.removeAllListeners('connectionStatusChanged');
    window.removeEventListener('online', onOnline);
    window.removeEventListener('offline', onOffline);
    yield put({ type: types.RESET_PRAYER_FEATURE });
    logUI('MBHWeb.PrayerWall.' + types.RESET_PRAYER_FEATURE, new Date(), tools.getURLPath(), null, prayerFeature.memberId);
}

export function* handleQueryAllPosts(data) {
    let response = null;
    const prayerFeature = yield select(state => state.prayerFeature);
    try {
        logUI('MBHWeb.PrayerWall.' + types.GET_ALL_PRAYERS, new Date(), tools.getURLPath(), null, prayerFeature.memberId);
        response = yield call(queryAllPosts);
    }
    catch (error) {
        yield put({ type: types.GET_ALL_PRAYERS_FAILURE });
        console.log(error);
        logUI('MBHWeb.PrayerWall.' + types.GET_ALL_PRAYERS_FAILURE, new Date(), tools.getURLPath(), { error }, prayerFeature.memberId);
    }
    finally {
        if (data && data.callback) {
            data.callback(response);
        }
    }
}

export function* handleQueryAllPostsSuccess(data) {
    const prayerFeature = yield select(state => state.prayerFeature);
    const prayers = data && data.allPrayers;
    const gotNewPost = prayers && prayers.length > 0 && prayers[0].createdAt > prayerFeature.lastLoadTime;
    yield put({ type: types.UPDATE_LAST_LOAD_TIME });
    logUI('MBHWeb.PrayerWall.' + types.UPDATE_LAST_LOAD_TIME, new Date(), tools.getURLPath(), { gotNewPost }, prayerFeature.memberId);
    if (data && data.callback) {
        data.callback(gotNewPost);
    }
}

export function* handleQueryMyPosts(data) {
    let response = null;
    const prayerFeature = yield select(state => state.prayerFeature);
    try {
        logUI('MBHWeb.PrayerWall.' + types.GET_MY_PRAYERS, new Date(), tools.getURLPath(), null, prayerFeature.memberId);
        response = yield call(queryMyPosts, prayerFeature.memberId);
    }
    catch (error) {
        yield put({ type: types.GET_MY_PRAYERS_FAILURE });
        logUI('MBHWeb.PrayerWall.' + types.GET_MY_PRAYERS_FAILURE, new Date(), tools.getURLPath(), null, prayerFeature.memberId);
        console.log(error);
    }
    finally {
        if (data && data.callback) {
            data.callback(response);
        }
    }
}

export function* handleRefreshAllPrayers() {
    if (yield isConnected()) {
        yield call(handleQueryAllPosts);
    }
}

export function* handleRefreshMyPrayers(data) {
    if (yield isConnected()) {
        yield call(handleQueryMyPosts, data);
    }
}

export function* handleNextPrayers(data) {
    let gotMore = false;
    let error = null;
    const prayerFeature = yield select(state => state.prayerFeature);
    try {
        if (yield isConnected()) {
            const { activeTab, liveMyPrayers } = prayerFeature;
            const livePrayers = (activeTab === '1' && prayerFeature.livePrayers) || (activeTab === '2' && liveMyPrayers) || null;
            if (livePrayers && livePrayers.hasMore && livePrayers.loadingStatus === 'loaded') {
                livePrayers.nextPage();
                gotMore = true;
            }
        }
        else {
            error = 'not connected';
        }
    }
    catch (e) {
        error = e || 'got error';
    }
    finally {
        logUI('MBHWeb.PrayerWall.' + types.GET_NEXT_PRAYERS + (error ? ".Failure" : ".Success"), new Date(), tools.getURLPath(), { gotMore, error }, prayerFeature.memberId);
        yield put({ type: types.GET_NEXT_PRAYERS_COMPLETED, gotMore });
        if (data.callback) {
            data.callback(gotMore, error);
        }
    }
}

export function* handlePostPrayer(payload) {
    let response = null;
    let success = false;
    const prayerFeature = yield select(state => state.prayerFeature);
    const post = payload.prayer;
    try {
        logUI('MBHWeb.PrayerWall.' + types.POST_PRAYER, new Date(), tools.getURLPath(), post, prayerFeature.memberId, post.topics[0]);
        response = yield call(postPrayer, post, payload.memberId);
        success = true;
        yield put({ type: types.POST_PRAYER_SUCCESS, myRecentPrayerPostId: response.postId, topic: post.topics[0] });
        if (prayerFeature[consts.HIDE_PRAYER_CARD_TOOLTIP] === undefined) {
            const preference = yield call(getUserPreference, consts.HIDE_PRAYER_CARD_TOOLTIP);
            const hidePrayerCardTooltip = preference && preference.length && preference[0].PreferenceValue
            response[consts.HIDE_PRAYER_CARD_TOOLTIP] = hidePrayerCardTooltip === 'true';
        }
        else {
            response[consts.HIDE_PRAYER_CARD_TOOLTIP] = prayerFeature[consts.HIDE_PRAYER_CARD_TOOLTIP].value;
        }
        logUI('MBHWeb.PrayerWall.' + types.POST_PRAYER_SUCCESS, new Date(), tools.getURLPath(), response, prayerFeature.memberId, post.topics[0]);
    }
    catch (error) {
        console.log('post prayer error:', error);
        yield put({ type: types.POST_PRAYER_FAILURE, error: error ?? 'failed to post prayer', hasBanWord: error.code === ErrorCode.BanWordFound });
        logUI('MBHWeb.PrayerWall.' + types.POST_PRAYER_FAILURE, new Date(), tools.getURLPath(), { ...post, hasBanWord: error.code === ErrorCode.BanWordFound }, prayerFeature.memberId, post.topics[0]);
    }
    finally {
        if (payload.callback) {
            payload.callback(response, !success);
        }
    }
}

export function* handleEditPrayer(payload) {
    let response = null;
    let success = false;
    const prayerFeature = yield select(state => state.prayerFeature);
    try {
        logUI('MBHWeb.PrayerWall.' + types.EDIT_PRAYER, new Date(), tools.getURLPath(), payload, prayerFeature.memberId, payload.postId);
        response = yield call(editPost, payload.postId, payload.textInput, payload.memberId);
        success = true;
        console.log('edit prayer response:', response);
        yield put({ type: types.EDIT_PRAYER_SUCCESS, myEditPrayerPostId: response.postId, textInput: response.textInput });
        logUI('MBHWeb.PrayerWall.' + types.EDIT_PRAYER_SUCCESS, new Date(), tools.getURLPath(), response, prayerFeature.memberId, response.postId);
    }
    catch (error) {
        console.log('edit prayer error:', error);
        yield put({ type: types.EDIT_PRAYER_FAILURE, error: error ?? 'failed to edit prayer', hasBanWord: error.code === ErrorCode.BanWordFound });
        logUI('MBHWeb.PrayerWall.' + types.EDIT_PRAYER_FAILURE, new Date(), tools.getURLPath(), { ...payload, hasBanWord: error.code === ErrorCode.BanWordFound }, prayerFeature.memberId, payload.postId);
    }
    finally {
        if (payload.callback) {
            payload.callback(response, !success);
        }
    }
}

export function* handleDeletePrayer(payload) {
    let success = false;
    const prayerFeature = yield select(state => state.prayerFeature);
    const post = payload.prayer;
    try {
        logUI('MBHWeb.PrayerWall.' + types.DELETE_PRAYER, new Date(), tools.getURLPath(), null, prayerFeature.memberId, post.postId);
        success = yield call(deletePrayer, post.postId);
        if (success) {
            yield put({ type: types.DELETE_PRAYER_SUCCESS, prayer: post });
        } else {
            yield put({ type: types.DELETE_PRAYER_FAILURE });
        }
        logUI('MBHWeb.PrayerWall.' + (success ? types.DELETE_PRAYER_SUCCESS : types.DELETE_PRAYER_FAILURE), new Date(), tools.getURLPath(), null, prayerFeature.memberId, post.postId);
    }
    catch (error) {
        yield put({ type: types.DELETE_PRAYER_FAILURE, error });
        logUI('MBHWeb.PrayerWall.' + types.DELETE_PRAYER_FAILURE, new Date(), tools.getURLPath(), error, prayerFeature.memberId, post.postId);
    }
    finally {
        if (payload.callback) {
            payload.callback(success);
        }
    }
}

export function* handleAddReaction(payload) {
    let success = false;
    const prayerFeature = yield select(state => state.prayerFeature);
    try {
        logUI('MBHWeb.PrayerWall.' + types.ADD_PRAYER_REACTION, new Date(), tools.getURLPath(), null, prayerFeature.memberId, payload.postId);
        success = yield call(addReaction, payload.postId);
        yield put({ type: types.ADD_PRAYER_REACTION_SUCCESS, success: success, postId: payload.postId });
        logUI('MBHWeb.PrayerWall.' + (success ? types.ADD_PRAYER_REACTION_SUCCESS : types.ADD_PRAYER_REACTION_FAILURE), new Date(), tools.getURLPath(), null, prayerFeature.memberId, payload.postId);
    }
    catch (error) {
        yield put({ type: types.ADD_PRAYER_REACTION_FAILURE, error });
        console.log('add prayer reaction failed', error);
        logUI('MBHWeb.PrayerWall.' + types.ADD_PRAYER_REACTION_FAILURE, new Date(), tools.getURLPath(), payload, prayerFeature.memberId);
    }
    finally {
        if (payload.callback) {
            payload.callback(success);
        }
    }
}

export function* handleRemoveReaction(payload) {
    let success = false;
    const prayerFeature = yield select(state => state.prayerFeature);
    try {
        logUI('MBHWeb.PrayerWall.' + types.REMOVE_PRAYER_REACTION, new Date(), tools.getURLPath(), null, prayerFeature.memberId, payload.postId);
        success = yield call(removeReaction, payload.postId);
        yield put({ type: types.REMOVE_PRAYER_REACTION_SUCCESS, success: success, postId: payload.postId });
        logUI('MBHWeb.PrayerWall.' + (success ? types.REMOVE_PRAYER_REACTION_SUCCESS : types.REMOVE_PRAYER_REACTION_FAILURE), new Date(), tools.getURLPath(), null, prayerFeature.memberId, payload.postId);
    }
    catch (error) {
        yield put({ type: types.REMOVE_PRAYER_REACTION_FAILURE, error });
        console.log('remove prayer reaction failed', error);
        logUI('MBHWeb.PrayerWall.' + types.REMOVE_PRAYER_REACTION_FAILURE, new Date(), tools.getURLPath(), payload, prayerFeature.memberId);
    }
    finally {
        if (payload.callback) {
            payload.callback(success);
        }
    }
}

export function* handleGetComments(payload) {
    try {
        const prayerFeature = yield select(state => state.prayerFeature);
        logUI('MBHWeb.PrayerWall.' + types.GET_COMMENTS, new Date(), tools.getURLPath(), null, prayerFeature.memberId, payload.postId);
        const liveObject = yield call(queryAllComments, payload.postId);
        yield put({ type: types.GET_COMMENTS_SUCCESS, postId: payload.postId });
        logUI('MBHWeb.PrayerWall.' + types.GET_COMMENTS_SUCCESS, new Date(), tools.getURLPath(), null, prayerFeature.memberId);
        payload.callback(liveObject);
    }
    catch (error) {
        yield put({ type: types.GET_COMMENTS_FAILURE, error });
        logUI('MBHWeb.PrayerWall.' + types.GET_COMMENTS_FAILURE, new Date(), tools.getURLPath(), { error, payload }, prayerFeature.memberId);
    }
}

export function* handleGetComment(payload) {
    try {
        const prayerFeature = yield select(state => state.prayerFeature);
        logUI('MBHWeb.PrayerWall.' + types.GET_COMMENT, new Date(), tools.getURLPath(), payload, prayerFeature.memberId, payload.commentId);
        const liveObject = yield call(getComment, payload.commentId);
        yield put({ type: types.GET_COMMENT_SUCCESS, commentId: payload.commentId });
        logUI('MBHWeb.PrayerWall.' + types.GET_COMMENT_SUCCESS, new Date(), tools.getURLPath(), payload, prayerFeature.memberId);
        payload.callback(liveObject);
    }
    catch (error) {
        yield put({ type: types.GET_COMMENT_FAILURE, error });
        logUI('MBHWeb.PrayerWall.' + types.GET_COMMENT_FAILURE, new Date(), tools.getURLPath(), { error, payload }, prayerFeature.memberId);
    }
}

export function* handleAddComment(payload) {
    let response = null;
    let success = false;
    const prayerFeature = yield select(state => state.prayerFeature);
    try {
        logUI('MBHWeb.PrayerWall.' + types.ADD_COMMENT, new Date(), tools.getURLPath(), payload.comment, prayerFeature.memberId, payload.comment.referenceId);
        response = yield call(addComment, payload.comment, payload.postId, payload.postUserId);
        success = true;
        yield put({ type: types.ADD_COMMENT_SUCCESS, comment: response });
        logUI('MBHWeb.PrayerWall.' + types.ADD_COMMENT_SUCCESS, new Date(), tools.getURLPath(), response, prayerFeature.memberId, payload.comment.referenceId);
    }
    catch (error) {
        yield put({ type: types.ADD_COMMENT_FAILURE, error: error, commentHasBanWord: error.code === ErrorCode.BanWordFound });
        logUI('MBHWeb.PrayerWall.' + types.ADD_COMMENT_FAILURE, new Date(), tools.getURLPath(), { ...payload, hasBanWor: error.code === ErrorCode.BanWordFound }, prayerFeature.memberId);
    }
    finally {
        if (payload.callback) {
            payload.callback(response, !success);
        }
    }
}

export function* handleEditComment(payload) {
    let response = null;
    let success = false;
    const prayerFeature = yield select(state => state.prayerFeature);
    try {
        logUI('MBHWeb.PrayerWall.' + types.EDIT_COMMENT, new Date(), tools.getURLPath(), payload, prayerFeature.memberId);
        response = yield call(editComment, payload.commentId, payload.textInput);
        success = true;
        yield put({ type: types.EDIT_COMMENT_SUCCESS, comment: response });
        logUI('MBHWeb.PrayerWall.' + types.EDIT_COMMENT_SUCCESS, new Date(), tools.getURLPath(), response, prayerFeature.memberId);
    }
    catch (error) {
        console.log(error);
        yield put({ type: types.EDIT_COMMENT_FAILURE, error: error ?? 'failed to edit comment', hasBanWord: error.code === ErrorCode.BanWordFound });
        logUI('MBHWeb.PrayerWall.' + types.EDIT_COMMENT_FAILURE, new Date(), tools.getURLPath(), { ...payload, hasBanWor: error.code === ErrorCode.BanWordFound }, prayerFeature.memberId);
    }
    finally {
        if (payload.callback) {
            payload.callback(response, !success);
        }
    }
}

export function* handleDeleteComment(payload) {
    let success = false;
    const comment = payload.comment;
    const prayerFeature = yield select(state => state.prayerFeature);
    try {
        logUI('MBHWeb.PrayerWall.' + types.DELETE_COMMENT, new Date(), tools.getURLPath(), comment, prayerFeature.memberId, comment.referenceId);
        success = yield call(deleteComment, comment.commentId);
        console.log('delete comment result: ', success);
        if (success) {
            yield put({ type: types.DELETE_COMMENT_SUCCESS, comment });
        } else {
            yield put({ type: types.DELETE_COMMENT_FAILURE });
        }
        logUI('MBHWeb.PrayerWall.' + (success ? types.DELETE_COMMENT_SUCCESS : types.DELETE_COMMENT_FAILURE), new Date(), tools.getURLPath(), comment, prayerFeature.memberId, comment.referenceId);
    }
    catch (error) {
        console.log('delete comment error: ', error);
        yield put({ type: types.DELETE_COMMENT_FAILURE, error });
        logUI('MBHWeb.PrayerWall.' + types.DELETE_COMMENT_FAILURE, new Date(), tools.getURLPath(), { payload, error }, prayerFeature.memberId, comment.referenceId);
    }
    finally {
        if (payload.callback) {
            payload.callback(success);
        }
    }
}

export function* handleAddCommentReaction(payload) {
    let success = false;
    const prayerFeature = yield select(state => state.prayerFeature);
    try {
        logUI('MBHWeb.PrayerWall.' + types.ADD_COMMENT_REACTION, new Date(), tools.getURLPath(), payload, prayerFeature.memberId, payload.postId);
        success = yield call(addCommentReaction, payload.commentId);
        yield put({ type: types.ADD_COMMENT_REACTION_SUCCESS, success: success, postId: payload.postId });
        logUI('MBHWeb.PrayerWall.' + types.ADD_COMMENT_REACTION_SUCCESS, new Date(), tools.getURLPath(), { ...payload, success }, prayerFeature.memberId, payload.postId);
    }
    catch (error) {
        yield put({ type: types.ADD_COMMENT_REACTION_FAILURE, error });
        console.log('add comment reaction failed', error);
        logUI('MBHWeb.PrayerWall.' + types.ADD_COMMENT_REACTION_FAILURE, new Date(), tools.getURLPath(), { ...payload, error }, prayerFeature.memberId);
    }
    finally {
        if (payload.callback) {
            payload.callback(success);
        }
    }
}

export function* handleRemoveCommentReaction(payload) {
    let success = false;
    const prayerFeature = yield select(state => state.prayerFeature);
    try {
        logUI('MBHWeb.PrayerWall.' + types.REMOVE_COMMENT_REACTION, new Date(), tools.getURLPath(), payload, prayerFeature.memberId, payload.postId);
        success = yield call(removeCommentReaction, payload.commentId);
        yield put({ type: types.REMOVE_COMMENT_REACTION_SUCCESS, success: success, postId: payload.postId });
        logUI('MBHWeb.PrayerWall.' + types.REMOVE_COMMENT_REACTION_SUCCESS, new Date(), tools.getURLPath(), { ...payload, success }, prayerFeature.memberId, payload.postId);
    }
    catch (error) {
        yield put({ type: types.REMOVE_COMMENT_REACTION_FAILURE, error });
        console.log('remove comment reaction failed', error);
        logUI('MBHWeb.PrayerWall.' + types.REMOVE_COMMENT_REACTION_FAILURE, new Date(), tools.getURLPath(), { ...payload, error }, prayerFeature.memberId);
    }
    finally {
        if (payload.callback) {
            payload.callback(success);
        }
    }
}

export function* handleGetNotificationBadge() {
    const prayerFeature = yield select(state => state.prayerFeature);
    try {
        const domain = yield select(state => state.domain);
        logUI('MBHWeb.PrayerWall.' + types.GET_NOTIFICATION_BADGE, new Date(), tools.getURLPath(), null, prayerFeature.memberId);
        const response = yield call(getNotificationBadge, domain.t);
        yield put({ type: types.GET_NOTIFICATION_BADGE_SUCCESS, showBadge: response });
        logUI('MBHWeb.PrayerWall.' + types.GET_NOTIFICATION_BADGE_SUCCESS, new Date(), tools.getURLPath(), response, prayerFeature.memberId);
    }
    catch (error) {
        yield put({ type: types.GET_NOTIFICATION_BADGE_FAILURE, error });
        logUI('MBHWeb.PrayerWall.' + types.GET_NOTIFICATION_BADGE_FAILURE, new Date(), tools.getURLPath(), error, prayerFeature.memberId);
    }
}

export function* handlePostMarkNotificationBadgeAsRead() {
    const prayerFeature = yield select(state => state.prayerFeature);
    try {
        const domain = yield select(state => state.domain);
        const response = yield call(markNotificationBadgeAsRead, domain.t);
        if (response === 'Success') {
            logUI('MBHWeb.PrayerWall.' + types.POST_NOTIFICATION_BADGE_ASREAD, new Date(), tools.getURLPath(), null, prayerFeature.memberId);
            yield put({ type: types.POST_NOTIFICATION_BADGE_ASREAD_SUCCESS, response });
            yield put({ type: types.GET_NOTIFICATION_BADGE });
            logUI('MBHWeb.PrayerWall.' + types.POST_NOTIFICATION_BADGE_ASREAD_SUCCESS, new Date(), tools.getURLPath(), null, prayerFeature.memberId);
        }
        else {
            yield put({ type: types.POST_NOTIFICATION_BADGE_ASREAD_FAILURE, error: 'not successful' });
            logUI('MBHWeb.PrayerWall.' + types.POST_NOTIFICATION_BADGE_ASREAD_FAILURE, new Date(), tools.getURLPath(), null, prayerFeature.memberId);
        }
    }
    catch (error) {
        yield put({ type: types.POST_NOTIFICATION_BADGE_ASREAD_FAILURE, error });
        console.log(error);
        logUI('MBHWeb.PrayerWall.' + types.POST_NOTIFICATION_BADGE_ASREAD_FAILURE, new Date(), tools.getURLPath(), error, prayerFeature.memberId);
    }
}

export function* getUserPreference(PreferenceName) {
    const prayerFeature = yield select(state => state.prayerFeature);
    yield put({ type: types.GET_USER_PREFERENCE });
    try {
        const domain = yield select(state => state.domain);
        logUI('MBHWeb.PrayerWall.' + types.GET_USER_PREFERENCE, new Date(), tools.getURLPath(), { PreferenceName }, prayerFeature.memberId);
        const preference = yield call(accountApi.getUserPreferences2, domain.t, PreferenceName);
        yield put({ type: types.GET_USER_PREFERENCE_SUCCESS, PreferenceName, PreferenceValue: preference && preference.length && preference[0].PreferenceValue });
        logUI('MBHWeb.PrayerWall.' + types.GET_USER_PREFERENCE_SUCCESS, new Date(), tools.getURLPath(), preference, prayerFeature.memberId);
        return preference;
    }
    catch (error) {
        yield put({ type: types.GET_USER_PREFERENCE_FAILURE, PreferenceName: payload.PreferenceName, error: error || 'error getting user preference' });
        logUI('MBHWeb.PrayerWall.' + types.GET_USER_PREFERENCE_FAILURE, new Date(), tools.getURLPath(), error, prayerFeature.memberId);
    }
}

export function* handleUpdateUserPreference(payload) {
    const prayerFeature = yield select(state => state.prayerFeature);
    yield put({ type: types.GET_USER_PREFERENCE });
    try {
        const domain = yield select(state => state.domain);
        logUI('MBHWeb.PrayerWall.' + types.UPDATE_USER_PREFERENCE, new Date(), tools.getURLPath(), payload, prayerFeature.memberId);
        const preference = yield call(accountApi.resetUserPreferences2, domain.t, payload.PreferenceName, payload.PreferenceValue);
        yield put({ type: types.UPDATE_USER_PREFERENCE_SUCCESS, PreferenceName: payload.PreferenceName, PreferenceValue: preference && preference.PreferenceValue });
        logUI('MBHWeb.PrayerWall.' + types.UPDATE_USER_PREFERENCE_SUCCESS, new Date(), tools.getURLPath(), preference, prayerFeature.memberId);
    }
    catch (error) {
        yield put({ type: types.UPDATE_USER_PREFERENCE_FAILURE, PreferenceName: payload.PreferenceName, error: error || 'error updating user preference' });
        logUI('MBHWeb.PrayerWall.' + types.UPDATE_USER_PREFERENCE_FAILURE, new Date(), tools.getURLPath(), error, prayerFeature.memberId);
    }
}

export function* handleGetDeletedPosts(data) {
    let response = null;
    const prayerFeature = yield select(state => state.prayerFeature);
    try {
        const domain = yield select(state => state.domain);
        logUI('MBHWeb.PrayerWall.' + types.GET_DELETED_POSTS, new Date(), tools.getURLPath(), data, prayerFeature.memberId);
        response = yield call(getDeletedPosts, domain.t);
        yield put({ type: types.GET_DELETED_POSTS_SUCCESS, deletedPost: response });
        logUI('MBHWeb.PrayerWall.' + types.GET_DELETED_POSTS_SUCCESS, new Date(), tools.getURLPath(), response, prayerFeature.memberId);
    }
    catch (error) {
        yield put({ type: types.GET_DELETED_POSTS_FAILURE });
        logUI('MBHWeb.PrayerWall.' + types.GET_DELETED_POSTS_FAILURE, new Date(), tools.getURLPath(), error, prayerFeature.memberId);
    }
    finally {
        if (data && data.callback) {
            data.callback(response);
        }
    }
}

export function* handleMarkDeletedPostsAsRead() {
    const prayerFeature = yield select(state => state.prayerFeature);
    try {
        const domain = yield select(state => state.domain);
        logUI('MBHWeb.PrayerWall.' + types.MARK_DELETED_POST_ASREAD, new Date(), tools.getURLPath(), null, prayerFeature.memberId);
        const response = yield call(markDeletedPostsAsRead, domain.t);
        if (response === 'Success') {
            yield put({ type: types.MARK_DELETED_POST_ASREAD_SUCCESS });
            logUI('MBHWeb.PrayerWall.' + types.MARK_DELETED_POST_ASREAD_SUCCESS, new Date(), tools.getURLPath(), null, prayerFeature.memberId);
        }
        else {
            yield put({ type: types.MARK_DELETED_POST_ASREAD_FAILURE });
            logUI('MBHWeb.PrayerWall.' + types.MARK_DELETED_POST_ASREAD_FAILURE, new Date(), tools.getURLPath(), null, prayerFeature.memberId);
        }
    }
    catch (error) {
        console.log(error);
        logUI('MBHWeb.PrayerWall.' + types.MARK_DELETED_POST_ASREAD_FAILURE, new Date(), tools.getURLPath(), error, prayerFeature.memberId);
    }
}